import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone';
import GetAttachments from './AttachmentItem';
import { KTSVG } from '../../_metronic/helpers';
import { AttachmentUpload } from './AttachmentUpload';
import { useTranslation } from 'react-i18next';
import { getValueFromResource } from '../../common/timeLiveFunction';
import { useAppDispatch } from '../../app/hooks';
const AttachmentModal = (props: any) => {

  const {isOpen, closeModal, Id, IsUploadRequired, AccountAttachmentTypeId} = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  return (
    <>
      <div className={`modal drawer-overlay ${isOpen ? "" : "fade"}`} style={{display : `${isOpen ? "block" : "none"}`}} 
      tabIndex={-1} id="attachmentModel" 
      data-bs-backdrop="false"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content rounded">
            <div className="modal-header" style={{ padding: '.6rem 1.6rem' }}>
              <h5 className="modal-title">
                {/* {t('Attachment Information')} */}
                {getValueFromResource('Attachment Information',dispatch, t)}
                </h5>
              <div
                className="btn btn-icon"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr061.svg"
                  className="svg-icon svg-icon-1x"
                />
              </div>
            </div>
            <div className="modal-body"  >
              {IsUploadRequired ? (
                <>
                  <AttachmentUpload Id={Id} />
                  <hr></hr>
                </>
              ) : null
              }
              <GetAttachments Id={Id} AccountAttachmentTypeId={AccountAttachmentTypeId} IsShowEmployeeInformation={true} />
            </div>
            <div className="modal-footer" style={{ padding: '1.6rem 1.6rem' }}>
              <button
                type="button"
                className="btn btn-secondary btn-bs-btn-font-weight"
                data-bs-dismiss="modal"
                onClick={closeModal}
              >
                {/* {t('Cancel')} */}
                {/* {getValueFromResource('Cancel',dispatch, t)} */}
                {getValueFromResource('Close',dispatch, t)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AttachmentModal